export default __webpack_public_path__ + "static/media/3.3868e61e.jpeg";